export default function removeFromReducer(state, action) {
	return state.filter(element => element !== action.element);
}
